import React from 'react';
import EcoClub1Class2025 from '../views/EcoClub1Class2025/EcoClub1Class2025';

const DesktopAppPage = () => {
  return <EcoClub1Class2025 />;
};

export default DesktopAppPage;
